import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import api from "services/api";

import { setDefaultCurrency } from "stores/balance/userBalance";
//New structured call
import BuyGoldCoins from "components/BuyGoldCoins";
import Swal from "sweetalert2";
import SweepCoinBalance from "components/SweepCoinBalance";
import Translator, { __ } from "services/Translator";
import moneyFormatter from "services/moneyFormatter";

function CoinSwitcherDual(props) {
  const dispatch = useDispatch();
  const userBalance = useSelector((state) => state.userBalance);
  //Newly added for the component

  const [buyGoldPlanData, setBuyGoldPlanData] = useState({
    planId: "",
    planPrice: "",
    GC: 0,
    SC: 0,
    openWallet: false,
  });
  const [showBuyModal, setShowBuyModal] = useState(false);
  const callDepositModal = (receiveVal) => {
    console.log("receiveVal", receiveVal);
    setBuyGoldPlanData({
      ...buyGoldPlanData,
      planId: receiveVal.planId,
      planPrice: receiveVal.planPrice,
      openWallet: receiveVal.openWallet,
      GC: receiveVal.GC,
      SC: receiveVal.SC,
    });
  };

  const toggleCurrency = async (ev) => {
    // alert(ev);
    // var target = ev.target;
    // var checked = ev.target.checked;

    // return;
    var selectedBalance;
    if (userBalance.selectedBalance === "SC") {
      dispatch(setDefaultCurrency("GC"));
      selectedBalance = "GC";
    } else if (userBalance.selectedBalance === "GC") {
      dispatch(setDefaultCurrency("SC"));
      selectedBalance = "SC";
    }

    var response = await api.post("/sweepstake-switch-balance", {
      selectedBalance: selectedBalance,
    });

    if (response.status === 200) {
      dispatch(setDefaultCurrency(selectedBalance));
    } else {
      Swal.fire({
        title: "warning!",
        text: response.data.message,
        icon: "warning",
        background: "#2e2e2e", // Dark background color
        color: "#fff", // White text color
        customClass: {
          popup: "dark-theme-popup",
          title: "dark-theme-title",
          content: "dark-theme-content",
        },
      });
    }
  };
  return (
    <>
      <BuyGoldCoins
        callDepositModal={callDepositModal}
        showBuyModal={showBuyModal}
        {...props}
      />

      <div className="coin-area">
        <div
          onClick={() => {
            toggleCurrency("CG");
          }}
          className={"gold-coin-area " + userBalance.selectedBalance}
        >
          <img
            alt=""
            src={require("assets/winnabull/images/cashierModal/gold-coin.png")}
          />
          <label>
            {moneyFormatter.numberFormat(userBalance.bonus_balance)}
          </label>
          <Link
            onClick={() => {
              setShowBuyModal(true);
              setTimeout(function () {
                setShowBuyModal(false);
              }, 500);
            }}
          >
            +
          </Link>
        </div>
        <div
          onClick={() => {
            toggleCurrency("SC");
          }}
          className={"sweep-coin-area " + userBalance.selectedBalance}
        >
          <img
            alt=""
            src={require("assets/winnabull/images/cashierModal/sweep-coin.png")}
          />
          <label>{moneyFormatter.numberFormat(userBalance.cash_balance)}</label>
          <Link
            onClick={() => {
              setShowBuyModal(true);
              setTimeout(function () {
                setShowBuyModal(false);
              }, 500);
            }}
          >
            +
          </Link>
        </div>
      </div>
      <SweepCoinBalance buyGoldPlanData={buyGoldPlanData} {...props} />
    </>
  );
}

export default CoinSwitcherDual;
